/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/InputButton',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'Managers/KeyboardManager', 'Managers/ScaleManager'],

    function (PIXI, Absolute, _, MsftButton, KeyboardManager, ScaleManager) {

        var InputButton = function (options, game) {

            var defaultOptions = {
                text: '',
                setting: '',
                labelLetterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 23 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 23 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#000001',
                    align: 'left'
                },
                buttonOptions: {
                    text: 'Broken',
                    threeSlice: {
                        multistate: true,
                        images: {
                            left: 'MS_3slice_btn_greymodal_01.png',
                            center: 'MS_3slice_btn_greymodal_02.png',
                            right: 'MS_3slice_btn_greymodal_03.png'
                        }
                    }
                },
                action: function (value) {
                },
                maxValueLength: 10

            };
            this.game = game;
            this._initInputButton(_.extend(defaultOptions, options));
        };

        InputButton.constructor = InputButton;
        InputButton.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        InputButton.prototype._initInputButton = function (options) {

            PIXI.DisplayObjectContainer.call(this);

            this.options = options;
            this.value = [];
            this.inputBoxBound = false;

            this.label = new PIXI.Text(this.options.text, this.options.labelLetterStyle);
            this.options.buttonOptions.letterStyle = this.options.letterStyle;
            this.options.buttonOptions.action = function () {};
            this.options.buttonOptions.text = Absolute.StringManager(this.options.buttonOptions.text);
            this.submitButton = new MsftButton(this.options.buttonOptions);

            this.createInputBox();
            this.submitButton.x = this.inputBox.x + this.inputBox.width + Absolute.Coords.x(20);
            this.submitButton.y = this.inputBox.y + (this.inputBox.height - this.submitButton.height) / 2;
            this.submitButton.width *= Absolute.ScreenMetrics.getResScale();
            this.submitButton.height *= Absolute.ScreenMetrics.getResScale();

            this.valueDisplay = new PIXI.Text(' ', this.options.letterStyle);
            this.valueDisplay.x = Absolute.Coords.x(15);
            this.valueDisplay.y = this.inputBox.y + Absolute.Coords.y(12);

            this.addChild(this.label);
            this.addChild(this.valueDisplay);
            this.addChild(this.submitButton);

            this.tempInputField = document.getElementById('highScoreEntry');

            this._height = this.inputBox.height + Absolute.Coords.y(50);
        };

        InputButton.prototype.createInputBox = function () {

            this.inputBox = new PIXI.Graphics();
            this.inputBox.beginFill(0xffffff);
            this.inputBox.lineStyle(Absolute.Coords.x(2), 0x000000, 1);
            this.inputBox.drawRect(0, 0, Absolute.Coords.x(180), Absolute.Coords.y(60));
            this.inputBox.endFill();

            this.inputBox.hitArea = new PIXI.Rectangle(0, 0, this.inputBox.width, this.inputBox.height);

            this.bindInteraction(this.inputBox, function () {

                if (Absolute.Platform._isAndroid()) {
                    var tmpValue = window.prompt(Absolute.StringManager('buttons.gameNumber'));
                    tmpValue = tmpValue.replace(/[^\w]/g, '');
                    this.value = tmpValue.split('');
                    this.tempInputField.value = '';
                    this.tempInputField.focus();
                    this.updateValueDisplay();
                    this.handleAction();
                } else {
                    this.updateTempInputField();
                    this.tempInputField.style.display = 'block';
                    this.tempInputField.focus();
                    this.updateValueDisplay();
                    this.inputBox.visible = false;
                    this.enable();
                }

            }.bind(this));

            this.inputBox.y = this.label.y + this.label.height + Absolute.Coords.y(20);

            this.addChild(this.inputBox);

        };

        InputButton.prototype.updateTempInputField = function () {
            var canvasOffsetStyleTop = '0px',
                canvasOffsetTop = parseInt(canvasOffsetStyleTop.slice(0, canvasOffsetStyleTop.indexOf('px'))),
                canvasOffsetStyleLeft = '0px',
                canvasOffsetLeft = parseInt(canvasOffsetStyleLeft.slice(0, canvasOffsetStyleLeft.indexOf('px')));
            var scale = ScaleManager.scaleFactorY <= 0.6 ? ScaleManager.scaleFactorY + 0.2 : 1;
            this.tempInputField.style.top = ((this.inputBox.worldTransform.ty * ScaleManager.scaleFactorY) + canvasOffsetTop) + 'px';
            this.tempInputField.style.left = ((this.inputBox.worldTransform.tx * ScaleManager.scaleFactorX) + canvasOffsetLeft) + 'px';
            this.tempInputField.style.width = (this.inputBox.width - Absolute.Coords.x(13)) * scale + 'px';
            this.tempInputField.style.height = (this.inputBox.height - Absolute.Coords.x(4)) * scale + 'px';
        };

        InputButton.prototype.bindInteraction = function (sprite, handler) {

            sprite.interactive = true;
            sprite.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                sprite.touchstart = handler.bind(this);
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    sprite.mousedown = handler.bind(this);
                }
            } else {
                sprite.mousedown = handler.bind(this);
            }

        };

        InputButton.prototype.handleAction = function () {
            if (!this.value.length) return;
            if (this.options.validate(this.value.join(''))) {

                if (this.tempInputField) {
                    // hide the keyboard on touch devices
                    this.tempInputField.blur();
                }
                this.options.action(this.options.settingPrefix, this.options.settingsKey, this.value.join(''));

                this.disable();

            }
        };

        InputButton.prototype.updateState = function (setting) {
        };

        InputButton.prototype._createTexture = function (type) {

            var container = new PIXI.DisplayObjectContainer(),
                radio = PIXI.Sprite.fromFrame(type == 'on' ? this.options.toggleOn : this.options.toggleOff),
                label = new PIXI.Text(this.options.text, this.options.letterStyle),
                textIndicator = new PIXI.Text(type == 'off' ? this.offLabel : this.onLabel, this.options.letterStyle);

            label.y = -label.height - Absolute.Coords.y(25);
            textIndicator.x = radio.width + Absolute.Coords.x(10);
            textIndicator.y = (radio.height - textIndicator.height) / 2 - Absolute.Coords.y(7);

            container.addChild(label);
            container.addChild(radio);
            container.addChild(textIndicator);

            return container.generateTexture();
        };

        InputButton.prototype.disable = function () {
            KeyboardManager.removeAnyKeyPressHandler();
            KeyboardManager.removeAnyKeyHandler(this.handlerRef);
            this.inputBoxBound = false;
            this.value = [];
            this.tempInputField.style.display = 'none';
            this.updateValueDisplay();
            this.inputBox.visible = true;
        };

        InputButton.prototype.enable = function () {
            if (!this.inputBoxBound) {
                this.handlerRef = this.handleKeyPress.bind(this);
                KeyboardManager.setAnyKeyPressHandler(this.handlerRef);
                KeyboardManager.setAnyKeyHandler(this.handlerRef);
                this.inputBoxBound = true;
            }
        };

        InputButton.prototype.addLetter = function (letter) {

            this.value.push(letter);
            this.tempInputField.value = this.value.join('');
            this.updateValueDisplay();
        };

        InputButton.prototype.removeLetter = function () {
            this.value.pop();
            this.updateValueDisplay();
        };

        InputButton.prototype.updateValueDisplay = function () {

            this.tempInputField.value = this.value.join('');
        };

        InputButton.prototype.handleKeyPress = function (event) {

            var code = 0, char = null, handled = false;
            if (event.which == null) {
                code = event.keyCode; // IE
            } else if (event.which != 0) {
                code = event.which;   // the rest
            }

            if (code === 13) { // enter
                if (this.value.length >= 1) {
                    this.handleAction();
                    handled = true;
                }
            } else if (code === 8) { //backspace
                this.removeLetter();
                handled = true;
            } else if (this.value.length < this.options.maxValueLength) {

                // 48 - 57 numbers
                // 96 - 105 numpad
                char = String.fromCharCode(code).toUpperCase();
                if ((/[0-9]/g).test(char)) {
                    this.addLetter(char);
                    handled = true;
                } else {
                    window.setTimeout(function () {
                        this.updateValueDisplay();
                    }.bind(this), 500)
                }
            }

            return handled;

        };

        InputButton.prototype.onMenuToggle = function (isOpen) {

            if (isOpen) {
                //this.enable();
            } else {
                this.disable();
            }

        };

        return InputButton;

    });

